<template>
  <b-modal
    id="all-seller-modal"
    :visible="visible"
    @hide="$emit('close')"
    hide-footer
    title="All Sellers Rep"
    centered
  >
      <div class="d-flex gap-2 flex-wrap">
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
      <p class="split-pill mb-2 mr-2">Joy Smith</p>
    </div>
    <!-- <div class="d-flex justify-content-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">Close</b-button>
    </div> -->
  </b-modal>
</template>

<script>
export default {
  name: "AllSeller",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
  #all-seller-modal .modal-body{
    padding-top: 0 !important;
  }
</style>
